import { RequiredError as d } from "./base.js";
var a = "https://example.com", u = function(n, e, t) {
  if (t == null) throw new d(e, `Required parameter ${e} was null or undefined when calling ${n}.`);
};
function o(n, e, t = "") {
  e != null && (typeof e == "object" ? Array.isArray(e) ? e.forEach((s) => o(n, s, t)) : Object.keys(e).forEach((s) => o(n, e[s], `${t}${t !== "" ? "." : ""}${s}`)) : n.has(t) ? n.append(t, e) : n.set(t, e));
}
var l = function(n, ...e) {
  const t = new URLSearchParams(n.search);
  o(t, e), n.search = t.toString();
}, v = function(n, e, t) {
  const s = typeof n != "string";
  return (s && t && t.isJsonMime ? t.isJsonMime(e.headers["Content-Type"]) : s) ? JSON.stringify(n !== void 0 ? n : {}) : n || "";
}, R = function(n) {
  return n.pathname + n.search + n.hash;
}, $ = function(n, e, t, s) {
  return (r = e, f = t) => {
    var i;
    const c = {
      ...n.options,
      url: (r.defaults.baseURL ? "" : (i = s == null ? void 0 : s.basePath) !== null && i !== void 0 ? i : f) + n.url
    };
    return r.request(c);
  };
};
export {
  a as DUMMY_BASE_URL,
  u as assertParamExists,
  $ as createRequestFunction,
  v as serializeDataIfNeeded,
  l as setSearchParams,
  R as toPathString
};

//# sourceMappingURL=common.js.map